var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", {
      staticClass: "filter-sidebar-overlay",
      class: { active: _vm.isOpen },
      on: { click: _vm.close },
    }),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "filter-sidebar", class: { active: _vm.isOpen } },
      [
        _c("div", { staticClass: "filter-sidebar-header" }, [
          _c("span", { staticClass: "filter-sidebar-title" }, [
            _vm._v(_vm._s(_vm.title)),
          ]),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "filter-sidebar-close",
              attrs: { type: "button", "aria-label": "Close" },
              on: { click: _vm.close },
            },
            [
              _c(
                "svg",
                {
                  attrs: {
                    width: "24",
                    height: "24",
                    viewBox: "0 0 24 24",
                    fill: "none",
                    stroke: "currentColor",
                    "stroke-width": "2",
                  },
                },
                [
                  _c("line", {
                    attrs: { x1: "18", y1: "6", x2: "6", y2: "18" },
                  }),
                  _vm._v(" "),
                  _c("line", {
                    attrs: { x1: "6", y1: "6", x2: "18", y2: "18" },
                  }),
                ]
              ),
            ]
          ),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "filter-sidebar-content" },
          [
            _vm._l(_vm.facets, function (facet) {
              return _c(
                "div",
                { key: facet.id, staticClass: "filter-sidebar-section" },
                [
                  _c("h3", { staticClass: "filter-sidebar-section-title" }, [
                    _vm._v(_vm._s(facet.name)),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "filter-sidebar-colors" },
                    _vm._l(facet.values, function (value) {
                      return _c(
                        "div",
                        {
                          key: value.id,
                          staticClass: "filter-color-item",
                          class: { "is-selected": _vm.isSelected(value.id) },
                          attrs: {
                            title: value.name + " (" + value.count + ")",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.toggleFacet(value.id)
                            },
                          },
                        },
                        [
                          _c("span", {
                            staticClass: "filter-color-swatch",
                            class: "color-" + value.cssClass,
                          }),
                          _vm._v(" "),
                          _c("span", { staticClass: "filter-color-name" }, [
                            _vm._v(_vm._s(value.name)),
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "filter-color-count" }, [
                            _vm._v("(" + _vm._s(value.count) + ")"),
                          ]),
                        ]
                      )
                    }),
                    0
                  ),
                ]
              )
            }),
            _vm._v(" "),
            _c("div", { staticClass: "filter-sidebar-section" }, [
              _c("h3", { staticClass: "filter-sidebar-section-title" }, [
                _vm._v(_vm._s(_vm.sortingTitle)),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "filter-sidebar-sorting" },
                _vm._l(_vm.sortingOptions, function (label, key) {
                  return _c(
                    "label",
                    { key: key, staticClass: "filter-sidebar-option" },
                    [
                      _c("input", {
                        attrs: { type: "radio", name: "sorting" },
                        domProps: {
                          value: key,
                          checked: key === _vm.currentSorting,
                        },
                        on: {
                          change: function ($event) {
                            return _vm.selectSorting(key)
                          },
                        },
                      }),
                      _vm._v(" "),
                      _c("span", [_vm._v(_vm._s(label))]),
                    ]
                  )
                }),
                0
              ),
            ]),
          ],
          2
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }